import React, { useEffect } from 'react';
import { join } from 'path';
import { Route, Switch } from 'react-router-dom';
import { ZILLOW_TENANT_SCREENING_SERVICES, ZTSS_DASHBOARD, ZTSS_LANDING, ZTSS_PROPERTIES } from '../../constants/paths';
import LandingPage from './LandingPage';
import ListingWizardPage from './ListingWizardPage';
import DashboardPage from './DashboardPage';
import PropertiesPage from './PropertiesPage';
import { useDispatch } from 'react-redux';
import { navigatedToZtss } from '../../actions/ztssActions';

export default function TenantScreeningServicesPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(navigatedToZtss());
  }, [dispatch]);
  return (
    <Switch>
      <Route path={ZTSS_LANDING} render={() => <LandingPage />} />
      <Route path={ZTSS_DASHBOARD} render={() => <DashboardPage />} />
      <Route path={ZTSS_PROPERTIES} render={() => <PropertiesPage />} />
      <Route path={join(ZILLOW_TENANT_SCREENING_SERVICES, ':currentStep')} render={() => <ListingWizardPage />} />
    </Switch>
  );
}
